/**
 * Enum for module types used in polymorphic relationships
 * This exactly matches the ModuleType enum in the Prisma schema
 */
export enum ModuleTypeEnum {
  PROJECT = 'PROJECT',
  TASK = 'TASK',
  TICKET = 'TICKET',
  TASK_GROUP = 'TASK_GROUP',
  DEAL = 'DEAL',
  LEAD = 'LEAD',
  EVENT = 'EVENT',
  ENTITY = 'ENTITY',
  CONTRACT = 'CONTRACT',
  INVOICE = 'INVOICE',
  EXPENSE = 'EXPENSE',
  THREAD = 'THREAD',
  THREAD_COMMENT = 'THREAD_COMMENT',
  TIME_ENTRY = 'TIME_ENTRY',
  TEAM = 'TEAM',
  INVENTORY = 'INVENTORY',
  SUPPLIER = 'SUPPLIER',
  MEMBER = 'MEMBER',
  DOCUMENT = 'DOCUMENT',
  DOCUMENT_CATEGORY = 'DOCUMENT_CATEGORY',
  ORGANIZATION = 'ORGANIZATION',
  TODAY = 'TODAY',
  CUSTOM_FIELD = 'CUSTOM_FIELD',
  CUSTOM_COLLECTION = 'CUSTOM_COLLECTION',
  PERMISSION = 'PERMISSION',
  PERMISSION_SET = 'PERMISSION_SET',
  FEATURE_FLAG = 'FEATURE_FLAG',
  INTEGRATION = 'INTEGRATION',
  AI = 'AI',
  NOTE = 'NOTE',
  CONTACT = 'CONTACT',
  PROFILE = 'PROFILE',
  CALENDAR = 'CALENDAR',
  CYCLE_INSTANCE = 'CYCLE_INSTANCE',
  CYCLE_TEMPLATE = 'CYCLE_TEMPLATE',
  FORM = 'FORM',
  FORM_SUBMISSION = 'FORM_SUBMISSION',
  WORKFLOW = 'WORKFLOW',
  ANALYTICS = 'ANALYTICS',
  BILLING_AUTHORIZATION = 'BILLING_AUTHORIZATION',
  WORKSTREAM = 'WORKSTREAM',
  DEPLOYMENT = 'DEPLOYMENT',
  QUOTE = 'QUOTE',
  KNOWLEDGE_BASE = 'KNOWLEDGE_BASE',
  MARKETING = 'MARKETING',
  // Backing notes for note templates (hidden from note lists/search)
  NOTE_TEMPLATE = 'NOTE_TEMPLATE',
}

// Type guard to check if a string is a valid ModuleType
export function isValidModuleType(value: string): value is ModuleTypeEnum {
  return Object.values(ModuleTypeEnum).includes(value as ModuleTypeEnum)
}
